import { render, staticRenderFns } from "./BusinessSetting.vue?vue&type=template&id=5bc87c6b&"
import script from "./BusinessSetting.vue?vue&type=script&lang=js&"
export * from "./BusinessSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports